import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from '../ui/Modal'
import { MarkdownPreview } from './MarkdownPreview'
import { useAppStore } from '../../store/useAppStore'
import { WidthToggleButton } from '../topbar/WidthToggleButton'

export const FullScreenPreviewModal: React.FC = () => {
  const { t } = useTranslation()
  const isOpen = useAppStore(state => state.isFullScreenPreviewOpen)
  const setOpen = useAppStore(state => state.setFullScreenPreviewOpen)
  const isFullWidth = useAppStore(state => state.isFullWidth)
  const content = useAppStore(state => state.currentDocument?.content || '')

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={t('preview.fullScreenTitle', 'Full Screen Preview')}
      headerExtra={<WidthToggleButton />}
      size="full"
      showCloseButton={true}
      bodyClassName="!p-0 h-full bg-gray-50 dark:bg-gray-900"
      contentClassName="h-full"
    >
      <div className={`w-full ${isFullWidth ? 'max-w-none' : 'max-w-4xl mx-auto'} min-h-full bg-white dark:bg-gray-800 shadow-sm transition-all duration-300`}>
        <MarkdownPreview 
          content={content} 
          className={`px-6 ${isFullWidth ? '' : ''} py-6 pb-24`}
        />
      </div>
    </Modal>
  )
}
